export { default } from 'flows/core/pages/property-contact';
